import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const params = {},
    actions = {
        createAccount: {
            method: 'POST',
            url: `${BASE_PATH_API}/apm/accounts`
        },
        getAllPropertyTypes: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/propertyTypes`,
            isArray: true
        },
        getHistoricalLeadData: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/leads`,
            isArray: true
        },
        getLinkedBusinessId: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/linkedBusinessId`
        },
        getSingleSignInToken: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/token`
        },
        getLeads: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/linkedAccount/leads`,
            params: {
                '$count': true
            }
        },
        getLeadData: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/linkedAccount/leads/:leadId`,
        },
        getLeadStatuses: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/leadStatuses`,
            isArray: true
        },
        getStatus: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/linkedAccount/status`
        },
        getPagedLeads: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/linkedAccount/leadsPaged`
        },
        updateLeadStatusesInBulk: {
            method: 'PUT',
            url: `${BASE_PATH_API}/apm/linkedAccount/leadStatuses/bulk`
        },
        getLeadEventHistory: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/linkedAccount/leads/:leadId/eventHistory`
        },
        getLeadCreditReasons: {
            method: 'GET',
            url: `${BASE_PATH_API}/apm/leadCreditReasons`
        },
        requestLeadCredit: {
            method: 'POST',
            url: `${BASE_PATH_API}/apm/linkedAccount/requestLeadCredit`
        },
        createNoteForLead: {
            method: 'POST',
            url: `${BASE_PATH_API}/apm/linkedAccount/leads/:leadId/note`
        }
    };

export function ApmApi() {
    const service = createActions(actions, params);
    return service;
}
